import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieLc116s($integrationId: Int, $page: Int) {
    omieLc116s(integrationId: $integrationId, page: $page, limit: 30) {
      cCodigo
      cDescricao
    }
  }
`

export const useServiceLC116SelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieLc116s']))
      .then(data => {
        const result = data.map((item, index) => {
          return { id: index, name: item?.cDescricao, cCodServLC116: item?.cCodigo }
        })

        return result
      })
  }
}

const ServiceLC116Select = ({ onChange, value, filter, ...props }) => {
  const getOptions = useServiceLC116SelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default ServiceLC116Select
